import { View, ActivityIndicator, Text } from "react-native";
import Svg, { Path } from "react-native-svg";


export const LoadingSkeleton = ({ styles }) => (
  <View style={styles.loadingContainer}>
    <ActivityIndicator size="large" color="#2563eb" />
    <View style={styles.skeletonCard} />
    <View style={styles.skeletonCard} />
    <View style={[styles.skeletonCard, { height: 70 }]} />
  </View>
);

export const ExpandIcon = ({ size = 14, color = "#f9fafb" }) => (
  <Svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <Path d="M8 3H3v5" stroke={color} strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
    <Path d="M3 3l6 6" stroke={color} strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
    <Path d="M16 21h5v-5" stroke={color} strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
    <Path d="M21 21l-6-6" stroke={color} strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
  </Svg>
);

export const CompressIcon = ({ size = 14, color = "#f9fafb" }) => (
  <Svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <Path d="M9 3H3v6" stroke={color} strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
    <Path d="M3 9l7-7" stroke={color} strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
    <Path d="M15 21h6v-6" stroke={color} strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
    <Path d="M21 15l-7 7" stroke={color} strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
  </Svg>
);

export const EyeIcon = ({ size = 14, color = "#f9fafb" }) => (
  <Svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <Path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7z" stroke={color} strokeWidth={2} />
    <Path d="M12 15a3 3 0 100-6 3 3 0 000 6z" stroke={color} strokeWidth={2} />
  </Svg>
);

export const BoltIcon = ({ size = 14, color = "#f9fafb" }) => (
  <Svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <Path d="M13 2L4 14h6l-1 8 9-12h-6l1-8z" stroke={color} strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
  </Svg>
);

export const ListIcon = ({ size = 14, color = "#f9fafb" }) => (
  <Svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <Path d="M8 6h13M8 12h13M8 18h13" stroke={color} strokeWidth={2} strokeLinecap="round" />
    <Path d="M3 6h.01M3 12h.01M3 18h.01" stroke={color} strokeWidth={2.5} strokeLinecap="round" />
  </Svg>
);

export const ChevronRightIcon = ({ size = 16, color = "#334155" }) => (
  <Svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <Path d="M9 6l6 6-6 6" stroke={color} strokeWidth={2.2} strokeLinecap="round" strokeLinejoin="round" />
  </Svg>
);

export const StatusBadge = ({ status, styles }) => {
  const badgeStyle = [styles.formStatusBadge];
  const textStyle = [styles.formStatusText];

  if (status === "Completed") {
    badgeStyle.push(styles.formStatusBadgeComplete);
    textStyle.push(styles.formStatusTextComplete);
  } else if (status === "Pending") {
    badgeStyle.push(styles.formStatusBadgePending);
    textStyle.push(styles.formStatusTextPending);
  } else {
    badgeStyle.push(styles.formStatusBadgeUnknown);
    textStyle.push(styles.formStatusTextUnknown);
  }

  return (
    <View style={badgeStyle}>
      <Text style={textStyle}>{status}</Text>
    </View>
  );
};